export interface GeoData {
    city: string;
    country: string;
    lat?: number;
    lng?: number;
}

const GEO_CACHE_KEY = 'qwiku_geo_cache';
const CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 hours

export async function getGeoData(): Promise<GeoData | null> {
    try {
        // Check cache first
        const cached = localStorage.getItem(GEO_CACHE_KEY);
        if (cached) {
            const { data, timestamp } = JSON.parse(cached);
            if (Date.now() - timestamp < CACHE_DURATION) {
                return data;
            }
        }

        // Fetch from API
        const response = await fetch('https://ipapi.co/json/');
        if (!response.ok) {
            throw new Error('Failed to fetch geo data');
        }

        const result = await response.json();

        // Extract relevant fields
        const geoData: GeoData = {
            city: result.city,
            country: result.country_name,
            //lat: result.latitude,
            //lng: result.longitude
        };

        // Cache the result
        localStorage.setItem(GEO_CACHE_KEY, JSON.stringify({
            data: geoData,
            timestamp: Date.now()
        }));

        return geoData;
    } catch (error) {
        console.warn('Geo lookup failed:', error);
        return null;
    }
}
